import path from 'path';

import { ItemCategoryEnum } from '~enums';
import { HubsService } from '~features/hub';
import { ItemGroupsService } from '~features/itemGroups';
import { OffsetPagedResults } from '~interfaces';
import { BasePagedParameters } from '~interfaces/requests';
import { BaseReferenceResponse, PagedResponse } from '~interfaces/responses';
import { TopologyService } from '~services';

import Item from '../interfaces/item';

class ItemsGroupItemsService extends TopologyService {
	/**
	 * Notice!! To prevent confusement. In this application (the admin panel)
	 * we the following terminilogy
	 * - Item = Instance aka ItemInstance
	 * - ItemGroup = Group of items (in other aspects of Topology may be referred as item)
	 * So the backend uses itemInstance for items
	 */
	public readonly path = 'items';
	public readonly itemsSubPath = 'iteminstances';

	/**
	 * Set the item group for this service.
	 * TODO: is this smart to already put the itemgroupid in the constructor?
	 * Means we need to reconstruct the service for every new itemGroupId
	 * @param itemGroupId
	 */
	constructor() {
		super('v1');
	}

	/**
	 * Get details from a single item
	 * @param id The item(instance) identifyer
	 * @returns
	 */
	async getItemById(itemGroupId: string, itemId: string): Promise<Item> {
		const { data } = await this._client.get<ItemResponse>(
			path.join(this.path, itemGroupId, this.itemsSubPath, itemId)
		);

		return ItemsGroupItemsService.fromResponse(data);
	}

	static fromResponse(data: ItemResponse): Item {
		const {
			id,
			name,
			category,
			itemReference,
			hubReference,
			organisationReference,
			isPublic,
			...rest
		} = data;

		return {
			...rest,
			...ItemsGroupItemsService.fromBaseReferenceResponse({
				id: id,
				name: name,
			}),
			isPublic: isPublic,
			organisation: ItemsGroupItemsService.fromBaseReferenceResponse(organisationReference),
			category: category as unknown as ItemCategoryEnum,
			// itemGroup: ItemsInItemGroupService.fromBaseReferenceResponse(itemReference),
			itemGroup: ItemGroupsService.fromResponse(itemReference),
			hub: HubsService.fromResponse(hubReference),
		};
	}
}

interface ItemResponse extends BaseReferenceResponse {
	organisationReference: BaseReferenceResponse;
	category: string;
	itemReference: BaseReferenceResponse;
	hubReference: {
		latitude: number;
		longitude: number;
		address: object;
	} & BaseReferenceResponse;
	isPublic: boolean;
}

export default ItemsGroupItemsService;
